"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ConnectIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ConnectIcon, _React$PureComponent);

  function ConnectIcon() {
    _classCallCheck(this, ConnectIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConnectIcon).apply(this, arguments));
  }

  _createClass(ConnectIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'connect-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M5.90949246,7.35390321 L4.64538712,6.09087689 L6.09050754,4.64684681 L7.3536128,5.91087314 L5.90949246,7.35390321 Z M11.7389782,0.261755453 C11.3889491,-0.0872518177 10.8229019,-0.0872518177 10.4738728,0.261755453 L8.87373948,1.86278881 C7.71664305,1.24877602 6.25252104,1.41477947 5.27743979,2.38979979 L4.9164097,2.75080731 C4.71739312,2.95081148 4.71739312,3.2738182 4.9164097,3.47282235 L5.18743229,3.743828 L3.74231186,5.18785808 L3.47228936,4.91685243 C3.27227269,4.71784829 2.94924577,4.71784829 2.75022919,4.91685243 L2.38819902,5.27885998 C1.41411784,6.25288027 1.24810401,7.71591075 1.8611551,8.87493489 L0.261021752,10.4749682 C-0.0870072506,10.8239755 -0.0870072506,11.3899873 0.261021752,11.7399946 C0.435036253,11.9139982 0.665055421,12 0.893074423,12 C1.12209351,12 1.35111259,11.9139982 1.52512709,11.7399946 L3.12626052,10.1389612 C4.28335695,10.752974 5.74747896,10.5859705 6.72156013,9.61195025 L7.0835903,9.24994271 C7.28260688,9.05093856 7.28260688,8.72793183 7.0835903,8.52792767 L6.81256771,8.25692202 L8.25768814,6.81289194 L8.52771064,7.08389758 C8.72672723,7.28390175 9.05075423,7.28390175 9.2507709,7.08389758 L9.6108009,6.72289006 C10.5868822,5.74886977 10.7528961,4.28483927 10.1388449,3.12681514 L11.7389782,1.52678181 C12.0870073,1.17777454 12.0870073,0.610762724 11.7389782,0.261755453 L11.7389782,0.261755453 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return ConnectIcon;
}(_react.default.PureComponent);

exports.default = ConnectIcon;
ConnectIcon.defaultProps = {
  color: 'inherit'
};
ConnectIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};